module.exports = __webpack_public_path__ + "img/company-stop.e6ed1811.png";